<template>
  <button
    class="brand"
    :class="{
      selected: isSelected,
      'not-available': !isAvailable,
      'lowest-price': isFirst,
    }"
    @click="selectBrand()"
  >
    <div class="select-area">
      <div class="dot" v-if="isAvailable">
        <div class="inner"></div>
      </div>
      <ELordIcon
        icon="questionMark"
        primary-color="#F7A111"
        secondary-color="#F7A111"
        v-else
      />
    </div>

    <div class="all-brands" v-if="brand.id === null">
      <span>{{ brand.name }}</span>
    </div>

    <div class="logo-area" v-if="brand.logo !== null">
      <img class="img" :src="brand.logo" />
      <div class="label" v-if="isFirst">
        <img :src="getIcon('checkmark-circle.svg')" />
        <span>{{ $t('global.word.lowest_price') }}</span>
      </div>
    </div>

    <div class="price-area" v-if="isAvailable && brand.price !== null">
      <span class="from">{{ $t('global.word.from') }}</span>
      <TweenPrice class="price" :price="vatPrice(brand.price / 100)" />
    </div>
    <div class="unavailable-area" v-if="!isAvailable">
      <p>{{ $t('BrandListItem.not_all_pieces_available') }}</p>
    </div>
  </button>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import TweenPrice from '../utilities/TweenPrice';
import ELordIcon from '../utilities/ELordIcon';

export default {
  name: 'BrandSelectionItem',
  components: { ELordIcon, TweenPrice },
  props: {
    brand: {
      type: Object,
      default: () => ({}),
    },
    isFirst: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState('filters', ['selectedBrandIds']),
    isSelected() {
      return this.selectedBrandIds.includes(this.brand.id);
    },
    isAvailable() {
      return this.brand.is_available === true;
    },
  },
  methods: {
    ...mapActions('filters', ['toggleSelectedBrandId']),
    ...mapMutations('popup', ['openPopup']),
    ...mapActions('brand-color-selection', ['fetchMissingProductIdsFromBrand']),
    selectBrand() {
      if (!this.isAvailable) {
        this.fetchMissingProductIdsFromBrand(this.brand.id);
        this.openPopup({
          metaData: { brandId: this.brand.id },
          type: 'brand',
        });
        return;
      }

      this.toggleSelectedBrandId(this.brand.id);
    },
  },
};
</script>
